import * as React from 'react';
import S from 's-js';
import * as $ from 'jquery';
import SuperCritical, { SuperCriticalComponent, SuperCriticalReference } from 'lib/supercritical';
import { CropImage } from './model';
import { PCModal } from 'portcall/pcmodal/view';
import 'lib/jcrop-loader';

// width and height of black background for image
const IMG_CONTAINER_WIDTH = 600,
    IMG_CONTAINER_HEIGHT = 400;

export const CropImageView = SuperCritical(({ modelContainer } : { modelContainer : () => CropImage | null }) =>
    <PCModal className="cropimage" shown={() => !!modelContainer()} onBackDropClick={modelContainer()?.Cancel}>
        <div className="modal-content">
            <div className="modal-header pc-modal-header">
                <h2 className="modal-title pc-modal-title">Edit Image</h2>
            </div>
            {modelContainer() && <CropCanvas model={modelContainer()!} />}
        </div>
    </PCModal>
);

class CropCanvas extends SuperCriticalComponent<{ model : CropImage }> {
    imageRef : (e : HTMLImageElement | null) => void;

    constructor(props : { model : CropImage }) {
        super(props);
        this.imageRef = SuperCriticalReference(this, InitImageCropper);
    }

    srender({ model: m } : { model : CropImage }) {
        return (
            <div className="modal-body clearfix">
                <div className="img-container">
                    <img className="raw-image" src={m.ImageUrl} ref={this.imageRef} />
                </div>
                <div className="img-controls">
                    <a className="pc-cancel-link" onClick={m.Cancel}>
                        Cancel
                    </a>
                    {' '}
                    <button className="pc-button" onClick={m.SaveSelection}>
                        Save
                    </button>
                </div>
            </div>
        );
    }    
}


function InitImageCropper({ model: m } : { model : CropImage }, image : HTMLImageElement) {
    let $image = $(image),
        $container = $image.closest('.img-container');

    // set container size
    $container.width(IMG_CONTAINER_WIDTH).height(IMG_CONTAINER_HEIGHT);

    let initializeJcrop = () => {
        $image.Jcrop({
            aspectRatio: 1,
            minSize: [m.MinSize, m.MinSize],
            boxWidth: IMG_CONTAINER_WIDTH - 2,
            boxHeight: IMG_CONTAINER_HEIGHT - 2,
            setSelect: m.InitialSelection.toArray(),
            allowSelect: false,
            keySupport: false,
            onSelect: c => m.OnJCropSelect(c) // Use latest props in case props change
        }, onLayoutComplete);
        image.removeEventListener('load', initializeJcrop);
    }

    let onLayoutComplete = () => {
        //center jcrop in container
        let $jcrop = $container.find('.jcrop-holder'),
            jcropWidth = $jcrop.width(),
            jcropHeight = $jcrop.height();

        $jcrop.css({
            'left': '50%',
            'margin-left': (-jcropWidth / 2) + 'px',
            'margin-top': (-jcropHeight / 2) + 'px',
            'position': 'absolute',
            'top': '50%'
        });
    }

    image.addEventListener('load', initializeJcrop);

    S.cleanup(() => {
        image.removeEventListener('load', initializeJcrop);
        let jcrop = $image.data('Jcrop');
        if (jcrop) jcrop.destroy();
    });
}


// WEBPACK FOOTER //
// ./apps/portcall/cropimage/view.tsx